import {
  CREATE_DIGITIZED_CONTRACT_SUCCESS,
  CREATE_DIGITIZED_CONTRACT_FAILURE,
} from '../actions/digitizedContracts';
import { showFlashMessage } from '../actions/ui';

const digitizedContracts =
  ({ dispatch }) =>
  next =>
  action => {
    switch (action.type) {
      case CREATE_DIGITIZED_CONTRACT_SUCCESS:
        dispatch(
          showFlashMessage('Contract uploaded', {
            type: 'success',
          }),
        );
        break;

      case CREATE_DIGITIZED_CONTRACT_FAILURE:
        dispatch(
          showFlashMessage(
            `${action.payload.message} Ensure file name doesn't include spaces or hyphens, and the file is a pdf`,
            {
              type: 'error',
            },
          ),
        );
        break;

      default:
        break;
    }

    // keep the train moving!
    return next(action);
  };

export default digitizedContracts;
